// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { ConnectionInfoItem } from '@shared/utils/ConnectionInfoItem';
class _ConnectionInfo {
    constructor() {
        this.ConnectionInfoArray = [];
        this.OnConnectionInfoArrayChanged = new CustomEvent();
    }
    SetConnectionsInfo(nonAssignedArray) {
        this.ConnectionInfoArray = nonAssignedArray.map((obj) => Object.assign(new ConnectionInfoItem(), obj));
    }
    GetConnectionInfoArray() {
        return this.ConnectionInfoArray;
    }
    SetActiveConnectionInfo(activeConnectionInfo) {
        this.activeConnectionInfo = activeConnectionInfo;
    }
    GetActiveConnectionInfo() {
        return this.activeConnectionInfo;
    }
}
export const ConntionInfo = new _ConnectionInfo();
